
export default function Solutions() {
  const boxes = [
    {
      icon: 'ri-git-branch-line',
      title: 'Origem dos Créditos',
      description: 'Um direito creditório nasce quando uma empresa realiza uma operação que gera um crédito reconhecido pelo sistema financeiro ou tributário.',
      points: [
        { icon: 'ri-building-2-line', text: 'Originados em operações comerciais, financeiras ou judiciais entre empresas' },
        { icon: 'ri-file-list-3-line', text: 'Representam valores a receber formalizados em contratos ou títulos' },
        { icon: 'ri-bank-line', text: 'Regulamentados pela CVM e pelo Banco Central do Brasil' },
        { icon: 'ri-shield-check-line', text: 'Estruturados por meio de FIDCs e veículos financeiros auditados' },
      ],
      color: 'from-feenex-blue/5 to-feenex-blue/10',
      accent: 'bg-feenex-blue/10',
      iconColor: 'text-feenex-blue',
    },
    {
      icon: 'ri-percent-line',
      title: 'Para quais impostos e empresas',
      description: 'A solução é voltada para empresas tributadas pelo Lucro Real ou Lucro Presumido que pagam impostos federais sobre o resultado.',
      points: [
        { icon: 'ri-money-dollar-circle-line', text: 'IRPJ — Imposto de Renda Pessoa Jurídica' },
        { icon: 'ri-coins-line', text: 'CSLL — Contribuição Social sobre o Lucro Líquido' },
        { icon: 'ri-bar-chart-2-line', text: 'Empresas do Lucro Real e Lucro Presumido' },
        { icon: 'ri-briefcase-4-line', text: 'Qualquer porte: médias e grandes empresas' },
      ],
      color: 'from-feenex-gold/5 to-feenex-gold/10',
      accent: 'bg-feenex-gold/10',
      iconColor: 'text-feenex-gold',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Economia e Legalidade',
      description: 'A operação com direitos creditórios é 100% legal, amparada pela legislação brasileira, e pode gerar economia tributária significativa.',
      points: [
        { icon: 'ri-arrow-down-circle-line', text: 'Redução de até 20% na carga de impostos federais' },
        { icon: 'ri-checkbox-circle-line', text: 'Operações auditáveis e com parecer jurídico' },
        { icon: 'ri-file-shield-2-line', text: 'Conformidade total com a Receita Federal' },
        { icon: 'ri-search-eye-line', text: 'Transparência absoluta em cada etapa da operação' },
      ],
      color: 'from-green-50 to-emerald-50',
      accent: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
    },
  ];

  return (
    <section id="solucoes" className="py-24 bg-feenex-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-feenex-gold/10 rounded-full mb-4">
            <span className="text-sm font-semibold text-feenex-gold uppercase tracking-wider">Nossas Soluções</span>
          </div>
          <h4 className="text-4xl lg:text-5xl font-bold text-feenex-blue mb-6">
            Redução de impostos com Direitos Creditórios
          </h4>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Operamos com direitos creditórios e ativo moeda para proporcionar até 20% de redução tributária legal, segura e transparente para sua empresa do Lucro Real ou Presumido.
          </p>
        </div>

        {/* Three Info Boxes */}
        <div className="grid md:grid-cols-3 gap-8">
          {boxes.map((box, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br ${box.color} rounded-lg border border-gray-100 p-8 hover:shadow-xl transition-all duration-500 group`}
            >
              {/* Icon + Title */}
              <div className="flex items-center gap-4 mb-5">
                <div className={`w-12 h-12 ${box.accent} rounded-lg flex items-center justify-center shrink-0`}>
                  <i className={`${box.icon} text-2xl ${box.iconColor}`}></i>
                </div>
                <h3 className="text-xl font-bold text-feenex-blue leading-snug">
                  {box.title}
                </h3>
              </div>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {box.description}
              </p>

              {/* Points */}
              <ul className="space-y-3">
                {box.points.map((point, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className={`w-6 h-6 ${box.accent} rounded-md flex items-center justify-center shrink-0 mt-0.5`}>
                      <i className={`${point.icon} text-sm ${box.iconColor}`}></i>
                    </div>
                    <span className="text-sm text-gray-700 leading-snug">{point.text}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 pt-6 border-t border-gray-200/60">
                <a
                  href="#contato"
                  className="inline-flex items-center gap-2 text-feenex-gold font-semibold hover:text-feenex-blue transition-colors cursor-pointer text-sm"
                >
                  Falar com especialista
                  <i className="ri-arrow-right-line text-base"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
